import { AddUserToCompanyProps } from '@commenda/types';
import { fetcher } from '@commenda/utils';

export async function addUserToCompany(
  companyId: number,
  user: AddUserToCompanyProps
): Promise<Response> {
  const res = await fetcher(`company/${companyId}/member`, {
    method: 'POST',
    body: user,
  });

  return res;
}
